import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import StringCell from '@/backgrid/StringCell';
import DollarCell from '@/backgrid/DollarCell';

import OrderSummaryGridView from '../../../views/OrderSummaryGridView/OrderSummaryGridView';

import tmplWideFormatSummaryView from './WideFormatSummaryView.hbs';

import './WideFormatSummaryView.css';

const WideFormatSummaryView = View.extend({
  template: tmplWideFormatSummaryView,

  className: 'wide-format-summary-view',

  ui: {
    summaryTable: '.summary-table'
  },

  regions: {
    summaryTable: '@ui.summaryTable'
  },

  onRender() {
    this.columns = [
      {
        name: 'item',
        label: 'Item',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'quantity',
        label: 'Quantity',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'totalPrice',
        label: 'Total Price',
        cell: DollarCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      }
    ];

    this.collection = new Backbone.Collection([
      {
        item: 'Printers',
        quantity: this.model.get('order').totalPrinterQuantity,
        totalPrice: this.model.get('order').totalPrinterPrice
      },
      {
        item: 'Scanners',
        quantity: this.model.get('order').totalScannerQuantity,
        totalPrice: this.model.get('order').totalScannerPrice
      },
      {
        item: 'Ink Cartridges',
        quantity: this.model.get('order').totalInkQuantity,
        totalPrice: this.model.get('order').totalInkPrice
      },
      {
        item: 'Order Total',
        quantity: this.model.get('order').totalOrderQuantity,
        totalPrice: this.model.get('order').totalOrderPrice
      }
    ]);

    this.orderSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.collection,
      columns: this.columns
    });
    this.showChildView('summaryTable', this.orderSummaryGridView);
  }
});

export default WideFormatSummaryView;
